module.exports = __webpack_public_path__ + "blissweb-md.55427178e9d3dd18b46c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Md/blissweb-md.ttf
// module id = 478
// module chunks = 5